import { camelCase } from "lodash";

const tealiumWording = (str) => {
  const words = str?.toLowerCase()?.split(/\s+/);
  return camelCase(words)?.replace(/[^a-zA-Z0-9]/g, "");
};

export default tealiumWording;
